// extracted by mini-css-extract-plugin
module.exports = {"pagesDiv":"Pages_pagesDiv__3U8eV","activo":"Pages_activo__dVJMU","inactivo":"Pages_inactivo__28q4A"};